import get from 'lodash/get'
import sumBy from 'lodash/sumBy'

import {
  ExternalPaymentRecordsQuery,
  OrderStatus,
  PaymentRecordStatus,
} from '__generated__/atlas-types'

import { getPaymentStatus } from 'payments/payments.transformations'

import {
  PaymentData,
  PaymentRecordStatus as TypedPaymentRecordStatus,
} from 'features/Orders/types'

const TOTAL_EXCLUDED_STATUS = [
  PaymentRecordStatus.REFUND_PROCESSING,
  PaymentRecordStatus.ERROR,
]

export const pillTextByStatus: Record<OrderStatus, string> = {
  [OrderStatus.IN_PROGRESS]: 'Draft',
  [OrderStatus.NOTES]: 'Note Order',
  [OrderStatus.ALL_NOTES]: 'Note Order',
  [OrderStatus.PENDING]: 'Pending',
  [OrderStatus.APPROVED]: 'Approved',
  [OrderStatus.SHIPPED]: 'Shipped',
  [OrderStatus.RETURNED]: 'Returned',
  [OrderStatus.CANCELLED]: 'Cancelled',
  [OrderStatus.NOTES_WITHOUT_QUANTITIES]: 'Notes w/out quantities',
  [OrderStatus.NOTES_WITH_QUANTITIES]: 'Notes w/ quantities',
}

export const getTotalExternalPayment = (
  externalPaymentRecords: ExternalPaymentRecordsQuery['externalPaymentRecords'],
): number =>
  sumBy(externalPaymentRecords, ({ status, amount }) =>
    status && !TOTAL_EXCLUDED_STATUS.includes(status) && amount ? amount : 0,
  )

export const getExternalPaymentData = (
  externalPaymentRecords: ExternalPaymentRecordsQuery['externalPaymentRecords'],
): PaymentData => {
  return {
    total: getTotalExternalPayment(externalPaymentRecords),
    localTotal: sumBy(externalPaymentRecords, ({ status, localAmount }) =>
      status && !TOTAL_EXCLUDED_STATUS.includes(status) && localAmount
        ? localAmount
        : 0,
    ),
    payments: [
      ...externalPaymentRecords.map((record) => ({
        ...record,
        date: record.created,
        currencyCode: record.currency,
        methodName:
          get(record.paymentMethod, 'brand') ||
          get(record.paymentMethod, 'bankName') ||
          '',
        amount: Math.abs(record.amount!),
        localAmount: record.localAmount ?? 0,
        localCurrency: record.localCurrency ?? '',
        status: getPaymentStatus(record) as TypedPaymentRecordStatus,
      })),
    ],
  }
}
